// resize sliders because for some reason they don't load correctly
setTimeout(function () {
    const sliderEls = document.querySelectorAll('.slider--room__slider.slider');
    [...sliderEls].forEach((el) => {
        Flickity.data(el).resize();
    });
}, 500);
